var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 62,
    viewBox: "0 0 255 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3539_38124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3057 60.8438C46.8742 60.8438 60.3057 47.4123 60.3057 30.8438C60.3057 14.2752 46.8742 0.84375 30.3057 0.84375C13.7371 0.84375 0.305664 14.2752 0.305664 30.8438C0.305664 47.4123 13.7371 60.8438 30.3057 60.8438Z",
    fill: "url(#paint0_linear_3539_38124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3063 0.84375C13.947 0.84375 0.655532 13.9404 0.322266 30.22C3.4785 44.1204 16.099 56.2328 30.3063 56.2328C44.8892 56.2328 57.5937 43.6419 60.2679 29.3226C59.4757 13.4611 46.3647 0.84375 30.3063 0.84375Z",
    fill: "url(#paint1_linear_3539_38124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7306 24.9894C57.0069 11.2242 44.8704 0.84375 30.3059 0.84375C15.7098 0.84375 3.55377 11.2698 0.865234 25.0794C1.83263 29.8696 4.46595 37.3695 11.6214 40.9706C22.6028 46.4969 50.0915 40.2528 54.2543 35.9464C57.1677 32.9326 59.0249 28.338 59.7306 24.9894Z",
    fill: "url(#paint2_linear_3539_38124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8537 18.9578C53.25 8.30284 42.6507 0.84375 30.3058 0.84375C17.5776 0.84375 6.70906 8.77414 2.35059 19.96C2.68825 23.6171 4.34698 30.3665 11.8369 34.3677C22.3158 39.966 36.3114 38.961 36.8855 38.6741C37.4596 38.3869 55.3312 28.18 55.3312 28.18C55.3312 28.18 58.2606 24.3997 57.8537 18.9578Z",
    fill: "url(#paint3_linear_3539_38124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5029 28.2428C55.5029 15.1194 44.2231 4.48047 30.3091 4.48047C16.3947 4.48047 5.11523 15.119 5.11523 28.2428C5.11523 34.8301 7.9582 40.7901 12.5487 45.0942C16.3195 41.3242 30.3091 26.9746 30.3091 26.9746L47.9094 45.2382C52.5919 40.9234 55.5029 34.905 55.5029 28.2428Z",
    fill: "url(#paint4_radial_3539_38124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3734 25.8341C52.308 22.7679 48.8709 18.9375 48.8709 18.9375L42.5549 21.1623C42.5549 21.1623 33.9423 25.0379 31.8531 26.9759C31.4827 27.3192 31.2482 27.5872 31.1094 27.8073L47.9087 45.2396C52.5917 40.9247 55.5023 34.9067 55.5023 28.2442C55.5023 27.4308 55.4582 26.6266 55.3734 25.8341Z",
    fill: "url(#paint5_linear_3539_38124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7646 28.5383L21.1109 37.5477L28.6104 30.3947L27.8635 25.5225C27.8635 25.5225 27.0089 24.6243 26.3248 24.8596C25.641 25.0956 11.7646 28.5383 11.7646 28.5383Z",
    fill: "url(#paint6_linear_3539_38124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0029 8.80899L37.6431 10.5573H41.1978C41.4274 10.5573 41.6575 10.6086 41.8547 10.7266C42.3512 11.023 43.0265 11.7104 42.8841 12.8662C42.6873 14.4669 41.9031 15.1135 41.9031 15.1135L43.3314 15.9752C43.3314 15.9752 44.8829 14.2269 44.6613 11.9856C44.5108 10.4633 43.1214 9.54314 42.2456 9.10945C41.8459 8.91181 41.409 8.80859 40.9633 8.80859H37.0029V8.80899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4837 8.80899L22.8436 10.5573H19.2889C19.0592 10.5573 18.8292 10.6086 18.6319 10.7266C18.1354 11.023 17.4601 11.7104 17.6025 12.8662C17.7994 14.4669 18.5835 15.1135 18.5835 15.1135L17.1552 15.9752C17.1552 15.9752 15.6037 14.2269 15.8254 11.9856C15.9758 10.4633 17.3653 9.54314 18.2411 9.10945C18.6407 8.91181 19.0776 8.80859 19.5233 8.80859H23.4837V8.80899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5488 45.0962C17.1037 49.367 23.379 52.0072 30.3092 52.0072C37.1598 52.0072 43.3678 49.4247 47.9095 45.2402L30.3092 26.9766C30.3088 26.9762 16.3196 41.3262 12.5488 45.0962Z",
    fill: "url(#paint7_linear_3539_38124)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8709 18.9382H35.0657V13.5195H25.2425V18.9386H11.7646V28.5401H25.1825V51.2875C25.1825 54.1077 27.469 56.3941 30.2892 56.3941C33.1093 56.3941 35.3958 54.1077 35.3958 51.2875V28.5397H48.8709V18.9382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1231 5.35938C27.0041 5.35938 24.4756 7.81427 24.4756 10.8425C24.4756 13.8707 27.0041 16.3256 30.1231 16.3256C33.2421 16.3256 35.7706 13.8707 35.7706 10.8425C35.7706 7.81427 33.2421 5.35938 30.1231 5.35938ZM30.1979 13.5574C28.7688 13.5574 27.6102 12.3988 27.6102 10.9697C27.6102 9.54061 28.7688 8.38198 30.1979 8.38198C31.627 8.38198 32.7857 9.54061 32.7857 10.9697C32.7857 12.3988 31.627 13.5574 30.1979 13.5574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8645 19.875H24.8533H24.7793H24.3008C24.3096 19.8978 24.6725 21.2241 25.6318 22.2687C26.5876 23.3125 28.1608 24.3655 30.5076 24.3631C31.4674 24.3635 32.3 24.091 32.9961 23.6874C34.0411 23.0808 34.7857 22.1875 35.2746 21.4481C35.7631 20.7084 36.0163 19.8882 36.0219 19.875H35.4538H35.4506C35.4098 19.9766 34.9909 20.9904 34.17 21.9362C33.7599 22.4095 33.2506 22.8712 32.6429 23.2117C32.0343 23.5521 31.3298 23.7742 30.508 23.7746C28.342 23.7722 26.9481 22.8256 26.0651 21.8702C25.6258 21.3925 25.3198 20.9124 25.1249 20.5543C25.0277 20.3751 24.9581 19.9774 24.9133 19.875H24.8645Z",
    fill: "#69E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.545 19.875H24.5398H24.539H24.3018H22.7803C22.7903 19.947 22.9183 21.6742 23.9161 23.4089C24.4162 24.2739 25.1471 25.1633 26.201 25.8334C27.0423 26.3707 28.0885 26.7512 29.332 26.8824V51.0448C29.332 51.5321 29.7269 51.9274 30.2146 51.9274C30.7019 51.9274 31.0971 51.5325 31.0971 51.0448V26.8952C32.3366 26.7764 33.3844 26.3831 34.2234 25.8258C34.9851 25.3225 35.5784 24.698 36.0369 24.0562C36.7251 23.0924 37.1179 22.0902 37.348 21.3233C37.5768 20.5559 37.6408 19.9126 37.6456 19.875H35.8929C35.8909 19.9162 35.6925 21.2541 34.8911 22.5875C34.4894 23.2601 33.9465 23.903 33.2164 24.3763C32.4838 24.848 31.5608 25.1697 30.301 25.1721H30.2998C28.9139 25.1697 27.9173 24.8308 27.1491 24.3451C26.5738 23.979 26.1249 23.5209 25.7689 23.0272C25.2352 22.2883 24.9195 21.4673 24.7455 20.836C24.6582 20.5207 24.6058 20.0586 24.5758 19.8754H24.545V19.875Z",
    fill: "#122045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3057 21.7656H85.1225V24.3585H82.141V39.9185H79.2881V24.3585H76.3057V21.7656Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9161 39.9185C93.7608 39.4517 93.657 39.1669 93.657 37.6876V34.8357C93.657 33.1506 93.0864 32.5276 91.79 32.5276H90.8041V39.9185H87.9521V21.7656H92.2568C95.2126 21.7656 96.4833 23.1402 96.4833 25.9407V27.3676C96.4833 29.2337 95.887 30.4272 94.6163 31.0235V31.075C96.0422 31.6713 96.509 33.0201 96.509 34.9137V37.7143C96.509 38.5954 96.5347 39.2441 96.8205 39.9185H93.9161ZM90.8032 24.3585V29.9347H91.9186C92.9817 29.9347 93.6304 29.468 93.6304 28.0153V26.2255C93.6304 24.9291 93.1893 24.3585 92.1787 24.3585H90.8032Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.191 39.9185H106.312L105.82 36.6246H102.319L101.826 39.9185H99.207L102.111 21.7656H106.286L109.191 39.9185ZM102.681 34.1612H105.43L104.082 24.9814H104.031L102.681 34.1612Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.69 26.7704H114.638V39.9185H112.071V21.7656H115.65L118.529 32.6314H118.58V21.7656H121.122V39.9185H118.191L114.69 26.7704Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.59 21.5586C131.365 21.5586 132.791 23.218 132.791 26.1223V26.6929H130.094V25.9413C130.094 24.6449 129.576 24.1524 128.669 24.1524C127.761 24.1524 127.243 24.6449 127.243 25.9413C127.243 27.2644 127.813 28.2493 129.68 29.883C132.066 31.9834 132.818 33.4875 132.818 35.5621C132.818 38.4665 131.366 40.1258 128.565 40.1258C125.764 40.1258 124.312 38.4665 124.312 35.5621V34.4467H127.008V35.7431C127.008 37.0396 127.579 37.5063 128.487 37.5063C129.394 37.5063 129.965 37.0396 129.965 35.7431C129.965 34.4201 129.394 33.4351 127.527 31.8014C125.141 29.7011 124.39 28.197 124.39 26.1223C124.39 23.218 125.816 21.5586 128.59 21.5586Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.488 26.2522V28.6117C144.488 31.516 143.088 33.0982 140.235 33.0982H138.886V39.9185H136.034V21.7656H140.235C143.088 21.7656 144.488 23.3469 144.488 26.2522ZM138.886 24.3585V30.5044H140.235C141.143 30.5044 141.635 30.0891 141.635 28.7927V26.0693C141.635 24.7729 141.143 24.3576 140.235 24.3576H138.886V24.3585Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.289 39.9185H153.411L152.918 36.6246H149.418L148.925 39.9185H146.306L149.21 21.7656H153.385L156.289 39.9185ZM149.781 34.1612H152.53L151.182 24.9814H151.13L149.781 34.1612Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.16 39.9185C165.005 39.4517 164.901 39.1669 164.901 37.6876V34.8357C164.901 33.1506 164.332 32.5276 163.034 32.5276H162.048V39.9185H159.196V21.7656H163.501C166.458 21.7656 167.727 23.1402 167.727 25.9407V27.3676C167.727 29.2337 167.131 30.4272 165.86 31.0235V31.075C167.287 31.6713 167.754 33.0201 167.754 34.9137V37.7143C167.754 38.5954 167.78 39.2441 168.066 39.9185H165.16ZM162.048 24.3585V29.9347H163.164C164.227 29.9347 164.875 29.468 164.875 28.0153V26.2255C164.875 24.9291 164.434 24.3585 163.424 24.3585H162.048Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.057 29.4156H177.973V32.0085H174.057V37.3256H178.985V39.9185H171.204V21.7656H178.985V24.3585H174.057V29.4156Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.923 26.7704H184.872V39.9185H182.305V21.7656H185.883L188.761 32.6314H188.813V21.7656H191.355V39.9185H188.424L184.923 26.7704Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.156 21.7656H202.974V24.3585H199.992V39.9185H197.14V24.3585H194.157V21.7656H194.156Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.675 33.1503V35.5621C219.675 38.4665 218.224 40.1258 215.422 40.1258C212.622 40.1258 211.17 38.4665 211.17 35.5621V26.1223C211.17 23.218 212.622 21.5586 215.422 21.5586C218.224 21.5586 219.675 23.218 219.675 26.1223V27.8855H216.979V25.9404C216.979 24.6439 216.408 24.1515 215.5 24.1515C214.592 24.1515 214.022 24.6439 214.022 25.9404V35.7431C214.022 37.0396 214.592 37.5063 215.5 37.5063C216.408 37.5063 216.979 37.0396 216.979 35.7431V33.1503H219.675Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.228 39.9185H229.349L228.857 36.6246H225.355L224.863 39.9185H222.243L225.148 21.7656H229.323L232.228 39.9185ZM225.718 34.1612H228.467L227.118 24.9814H227.067L225.718 34.1612Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.1 39.9185C240.944 39.4517 240.841 39.1669 240.841 37.6876V34.8357C240.841 33.1506 240.27 32.5276 238.974 32.5276H237.989V39.9185H235.136V21.7656H239.441C242.397 21.7656 243.669 23.1402 243.669 25.9407V27.3676C243.669 29.2337 243.072 30.4272 241.802 31.0235V31.075C243.229 31.6713 243.694 33.0201 243.694 34.9137V37.7143C243.694 38.5954 243.721 39.2441 244.006 39.9185H241.1ZM237.988 24.3585V29.9347H239.102C240.165 29.9347 240.814 29.468 240.814 28.0153V26.2255C240.814 24.9291 240.373 24.3585 239.362 24.3585H237.988Z",
    fill: "#38879F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.995 29.4156H253.91V32.0085H249.995V37.3256H254.922V39.9185H247.142V21.7656H254.922V24.3585H249.995V29.4156Z",
    fill: "#38879F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3539_38124",
    x1: 0.756522,
    y1: 25.6333,
    x2: 59.8547,
    y2: 36.0539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0628,
    stopColor: "#2F6C84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2158,
    stopColor: "#204E68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3655,
    stopColor: "#163855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5091,
    stopColor: "#0F2A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6397,
    stopColor: "#0D2645"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3539_38124",
    x1: 0.718837,
    y1: 25.4138,
    x2: 60.0234,
    y2: 31.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595,
    stopColor: "#489FA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2111,
    stopColor: "#33758E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3578,
    stopColor: "#22537B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4371,
    stopColor: "#1C4674"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3539_38124",
    x1: 0.865086,
    y1: 21.9946,
    x2: 59.7306,
    y2: 21.9946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0595,
    stopColor: "#54B2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8824,
    stopColor: "#306D84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3539_38124",
    x1: 30.1215,
    y1: 38.9303,
    x2: 30.1215,
    y2: 0.843698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#479E9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7126,
    stopColor: "#5ECCB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9405,
    stopColor: "#71E298"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3539_38124",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8453 16.051) scale(22.9131 22.9131)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#51B188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3861,
    stopColor: "#52B38B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6805,
    stopColor: "#58C1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8489,
    stopColor: "#5BC6B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3539_38124",
    x1: 35.5739,
    y1: 22.0758,
    x2: 54.7276,
    y2: 37.0403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1632,
    stopColor: "#275B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8368,
    stopColor: "#56BBC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3539_38124",
    x1: 16.6378,
    y1: 34.1773,
    x2: 24.8829,
    y2: 23.2358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#5BC6B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0758,
    stopColor: "#59C2B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3173,
    stopColor: "#449695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    stopColor: "#347681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7136,
    stopColor: "#2A6275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8368,
    stopColor: "#275B71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3539_38124",
    x1: 12.5486,
    y1: 39.4917,
    x2: 47.9093,
    y2: 39.4917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0611,
    stopColor: "#4AA1BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#1A426C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8193,
    stopColor: "#387EA8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3539_38124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 61,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHorizontal);
export default __webpack_public_path__ + "static/media/logo-horizontal.754ad531bce9c4d5985b61fc32d8659f.svg";
export { ForwardRef as ReactComponent };